import type { SettingsSource } from '../models/settings-hub.model';

import { action, field } from './settings-builders';
import { LETTERS_NUMBERS_UNDERSCORE_PATTERN, URL_WITH_SCHEME_PATTERN } from './settings-patterns';
import { SIGNUP_FORM_FIELDS } from './signup-form-fields';

export const CUSTOMERS_SUBCATEGORY: SettingsSource = {
    id: 'customers',
    cards: [
        {
            id: 'customers-options',
            settings: [
                field.toggle('backend.mail_receipts', 'SETTINGS.SETTINGS.AUTO_SEND_RECEIPTS'),
                field.toggle('backend.enable_customer_welcome_mail', 'SETTINGS.SETTINGS.ENABLE_CUSTOMER_WELCOME_MAIL'),
                field.chips('customers.custom_types', 'SETTINGS.SETTINGS.CUSTOM_CUSTOMER_TYPES', { storage: 'lines' }),
                field.toggle('customers.verify_vat_tax_code', 'SETTINGS.SETTINGS.VERIFY_CUSTOMER_VAT_TAX_CODE')
            ]
        },
        {
            id: 'fidelity',
            settings: [
                field.toggle('cashregister.print_fidelity_points', 'SETTINGS.SETTINGS.PRINT_FIDELITY_POINTS'),
                field.toggle('cashregister.show_fidelity_points', 'SETTINGS.SETTINGS.SHOW_FIDELITY_POINTS'),
                field.text('fidelity_prefix', 'SETTINGS.SETTINGS.FIDELITY_PREFIX', { maxLength: 10, pattern: LETTERS_NUMBERS_UNDERSCORE_PATTERN }),
                field.text('fidelity.current_message', 'SETTINGS.SETTINGS.MESSAGE_TRANSACTION_POINTS'),
                field.text('fidelity.prevtotal_message', 'SETTINGS.SETTINGS.MESSAGE_PREVIOUS_POINTS'),
                field.text('fidelity.total_message', 'SETTINGS.SETTINGS.MESSAGE_CURRENT_POINTS'),
                field.text('fidelity.fidelity_label', 'SETTINGS.SETTINGS.FIDELITY_LABEL'),
                field.image('digital_card.logo_url', 'SETTINGS.SETTINGS.FIDELITY_LOGO'),
                field.color('digital_card.primary_color', 'SETTINGS.SETTINGS.FIDELITY_COLOR', { defaultValue: '#000000', persistDefault: true })
            ]
        },
        {
            id: 'signup-form',
            settings: [
                {
                    id: 'signup_form.enabled',
                    preferenceKey: 'signup_form.enabled',
                    control: 'toggle',
                    label: 'SETTINGS.SETTINGS.SIGNUP_FORM_ENABLED',
                    disabledWhen: ({ values }) => !values['signup_form.url_privacy']
                },
                action('open-signup-form-preview', 'SETTINGS.SETTINGS.SIGNUP_FORM_PREVIEW', { icon: 'open_in_new' }),
                {
                    id: 'signup_form.url_privacy',
                    preferenceKey: 'signup_form.url_privacy',
                    control: 'text',
                    label: 'SETTINGS.SETTINGS.SIGNUP_FORM_URL_PRIVACY',
                    pattern: URL_WITH_SCHEME_PATTERN,
                    // The form cannot be enabled without the privacy policy
                    onChange: url => url ? {} : { 'signup_form.enabled': false }
                },
                field.textarea('signup_form.thankyou_message', 'SETTINGS.SETTINGS.SIGNUP_FORM_THANKYOU_MESSAGE'),
                field.toggle('signup_form.verify_mobile', 'SETTINGS.SETTINGS.SIGNUP_FORM_VERIFY_MOBILE'),
                field.toggle('signup_form.verify_email', 'SETTINGS.SETTINGS.SIGNUP_FORM_VERIFY_EMAIL'),
                field.toggle('signup_form.return_digital_cards', 'SETTINGS.SETTINGS.SIGNUP_FORM_RETURN_DIGITAL_CARDS'),
                {
                    id: 'signup_form.fields',
                    preferenceKey: 'signup_form.fields',
                    control: 'object-list',
                    label: 'SETTINGS.HUB.FIELDS.SIGNUP_FORM_FIELDS',
                    objectList: {
                        addLabel: 'SETTINGS.SETTINGS.SIGNUP_FORM_FIELDS_ADD',
                        addAction: 'add-signup-form-field',
                        reorderable: true,
                        caption: item => SIGNUP_FORM_FIELDS.find(field => field.name === item['name'])?.label,
                        fields: [
                            { key: 'label', label: 'SETTINGS.SETTINGS.LABEL', control: 'text', grow: 2 },
                            { key: 'required', label: 'SETTINGS.SETTINGS.SIGNUP_FORM_FIELD_REQUIRED', control: 'toggle' }
                        ]
                    }
                }
            ]
        }
    ]
};
